import { SWReactCountryIcons } from "@similarweb/icons";
import { Tooltip } from "@similarweb/ui-components";

import { headerDataAutomation } from "app/pages/activation/components/Header/dataAutomationKeys";
import CountryService from "app/services/CountryService";

import * as SC from "./styles";

type CountryIconSchema = {
    country: number;
};

export const CountryIcon = ({ country }: CountryIconSchema) => {
    const countryText = CountryService.getCountryById(country)?.text;

    return (
        <Tooltip
            content={countryText}
            enabled={!!countryText}
        >
            <SC.Container data-automation={headerDataAutomation.countryIcon}>
                <SWReactCountryIcons
                    countryCode={country}
                    size="sm"
                />
            </SC.Container>
        </Tooltip>
    );
};
